(function(Drupal, once) {
  Drupal.behaviors.linkAddIconOpenInNew = {
    attach(context) {
      const elements = once(
        "linkAddIconOpenInNew",
        '.text-formatted a[target="_blank"]',
        context
      );
      if (elements.length > 0) {
        elements.forEach((link) => {
          link.insertAdjacentHTML(
            "beforeend",
            '<span style="text-decoration: none;padding-left:.45em;font-size:.85em"><svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 512 512" style="height:1em; display:inline-block;vertical-align:-.25" fill="currentColor "><!--!Font Awesome Pro 6.7.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2024 Fonticons, Inc.--><path d="M336 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l121.4 0L212.7 276.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 54.6 480 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160c0-8.8-7.2-16-16-16L336 0zM64 32C28.7 32 0 60.7 0 96L0 448c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-144c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 144c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l144 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L64 32z"/></svg></span>'
          );
        });
      }
    },
  };
})(Drupal, once);
